/**
 * Classification duration text component.
 */
import Colors from '@shared/assets/style/default/color';
import Fonts from '@shared/assets/style/default/fonts';
import Screen from '@shared/utils/screen';
import styled from 'styled-components';

/**
 * Duration text shown to the left of score/age code in the classification row.
 */
const ClassificationDurationText = styled.span`
  color: ${Colors['text']};
  display: block;
  font-family: ${Fonts['thin']};
  font-size: ${28 * Screen.widthRatio}px;
  line-height: ${32 * Screen.widthRatio}px;
  margin-right: ${16 * Screen.widthRatio}px;
`;

export default ClassificationDurationText;
